import { CopilotConversationDTO } from 'models/dto/copilot/copilotConversationDTO';
import StringValueDTO from 'models/dto/stringValue/stringValueDTO';

export class CopilotStringValueDTO {
  stringValue: StringValueDTO;

  conversation: CopilotConversationDTO;

  constructor() {
    this.stringValue = new StringValueDTO();
    this.conversation = new CopilotConversationDTO();
  }
}
